import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { LabRequestService } from 'src/app/services/water-lab/lab-request.service';
import { CreateLabRequestComponent } from './request/create-lab-request/create-lab-request.component';



@Component({
  selector: 'bart-water-lab-main',
  templateUrl: './water-lab-main.component.html',
  styleUrls: ['./water-lab-main.component.scss'],
  providers: [DialogService]
})
export class WaterLabMainComponent implements OnInit {

  constructor(public dialogService: DialogService) {}

  ngOnInit() {
  }
  openCreateRequest_Popup()
  {
    const ref = this.dialogService.open(CreateLabRequestComponent, {
      header: 'Create Lab Request',
      width: '70%'
    });
  }
}
